import axios from 'axios';
import { AD_PLATFORM_TYPE, IScheduledAction, IScheduledActionSummary } from 'sl-ad-campaign-manager-data-model';
import {
  parseScheduledActionsIntoGroups,
  parseSummarizedScheduledActionsIntoGroups
} from 'src/store/modules/adManager/adScheduledActionGroups/selectors';
import { IScheduledActionsGroup } from 'src/store/modules/adManager/adScheduledActionGroups/types';

const BASE_URL = '/apiAdManager/scheduledActions';

export const fetchScheduledActionGroups = async (
  fetchSummary: boolean = false,
  platformType?: AD_PLATFORM_TYPE,
  scheduledActionGroupId?: string
): Promise<IScheduledActionsGroup[]> => {
  try {
    if (fetchSummary) {
      const res = await axios.get(`${BASE_URL}/summary`);
      return parseSummarizedScheduledActionsIntoGroups(res.data as IScheduledActionSummary[]).filter(
        (x) =>
          x.scheduleDetail.plan !== 'Expired' &&
          (x.scheduleDetail.action === 'Change my bid prices' || x.scheduleDetail.action === 'Change my budget') &&
          x.scheduledActions[0].scheduledAction.actionMethod !== 'Set' &&
          x.scheduledActions[0].scheduledAction.actionType !== 'metricBase'
      );
    }
    const query = new URLSearchParams();

    if (platformType) {
      query.set('platformType', platformType);
    }
    if (scheduledActionGroupId) {
      query.set('scheduledActionGroupId', scheduledActionGroupId);
    }

    const url = `${BASE_URL}${query ? `?${query.toString()}` : ''}`;

    const res = (await axios.get(url)) as IScheduledAction[];

    const parsedRes = parseScheduledActionsIntoGroups(res).filter((x) => {
      return x.scheduleDetail.plan !== 'Expired';
    });

    return parsedRes;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

export const fetchScheduledActionGroupsByEntity = async (entity: any): Promise<IScheduledActionsGroup[]> => {
  try {
    let apiName = '';
    const entityId = entity.id;
    let entityIdKey = '';
    if (entity.type === 'adCampaign') {
      entityIdKey = 'campaignId';
      apiName = 'getScheduledActionByCampaignId';
    }

    const body = {
      [entityIdKey]: entityId,
      platformType: entity.platformType
    };

    const res = await axios.post(`${BASE_URL}/${apiName}`, body);
    return parseSummarizedScheduledActionsIntoGroups(res.data as IScheduledActionSummary[]).filter(
      (x) =>
        x.scheduleDetail.plan !== 'Expired' &&
        (x.scheduleDetail.action === 'Change my bid prices' || x.scheduleDetail.action === 'Change my budget') &&
        x.scheduledActions[0].scheduledAction.actionMethod !== 'Set' &&
        x.scheduledActions[0].scheduledAction.actionType !== 'metricBase'
    );
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
